import { StatusColor } from './utils';
interface StatusChangeProps {
  fromValue: string;
  toValue: string;
}

export const BookingStatusChange = ({ fromValue, toValue }: StatusChangeProps) => (
  <>
    <span className="text-muted">from </span>
    <span className={StatusColor[fromValue]}>{fromValue}</span>
    <span className="text-muted"> to </span>
    <span className={StatusColor[toValue]}>{toValue}</span>
  </>
);
